export default __webpack_public_path__ + "f22845bcce63cf6911aee53a7368a788.svg";